import get from 'lodash/get';
import qs from 'query-string';
import {
  thunkHandler,
  thunkErrorHanlder,
  parseUrl,
  Consequence,
  segmentTrackEvent,
  segmentIdentifyUser,
  segmentGroup
} from '../../libs/utils';
import {
  AGENT_BASE,
  AGENT_COLLECTION_BASE,
  AGENT_COLLECTION_DATA,
  AGENT_CATALOGS_DATA,
  AGENT_PAYMENT_REQUEST,
  AGENT_RECURRING_PAYMENT_REQUEST,
  AGENT_CURRENCY,
  AGENT_REPORT,
  AGENT_CANCEL_REFERENCES,
  AGENT_COLLECTION_BASE_CALL,
  BASE_URL_GATEWAY,
  AGENT_PAYMENT_RECEIPTS_HISTORY,
  AGENT_PAYMENT_REPORT_HISTORY
} from '../../constants/endpoints';
import axios from 'axios';
import { downloadXls } from '../../libs/utils';
import runtimeConfig from '../../config/runtimeConfig';
import { applyAuth401Handler } from '../../libs/handle401';
import { fetchWithAuth } from '../../libs/fetchWithAuth';

export const NEW_AGENTS = 'NEW_AGENTS';
export const NEW_EXPORT_AGENTS = 'NEW_EXPORT_AGENTS';
export const SELECTED_PAYMENTS = 'SELECTED_PAYMENTS';
export const RESET_SELECTED_PAYMENTS = 'RESET_SELECTED_PAYMENTS';
export const DELETE_SELECTED_PAYMENTS = 'DELETE_SELECTED_PAYMENTS';
export const VALIDATE_TOKEN = 'VALIDATE_TOKEN';
export const VALIDATE_TOKEN_ERROR = 'VALIDATE_TOKEN_ERROR';
export const AGENTS_PENDINGS = 'AGENTS_PENDINGS';
export const AGENTS_CATALOGS = 'AGENTS_CATALOGS';
export const AGENTS_PAYMENT_REQUEST = 'AGENTS_PAYMENT_REQUEST';
export const AGENTS_PAYMENT_REQUEST_ERROR = 'AGENTS_PAYMENT_REQUEST_ERROR';
export const AGENTS_DOMICILIATION_REQUEST_ERROR = 'AGENTS_DOMICILIATION_REQUEST_ERROR';
export const AGENTS_PAYMENT_REQUEST_LOADING = 'AGENTS_PAYMENT_REQUEST_LOADING';
export const AGENTS_CURRENCY = 'AGENTS_CURRENCY';
export const AGENTS_CANCEL = 'AGENTS_CANCEL';
export const RESET_AGENTS_PENDINGS = 'RESET_AGENTS_PENDINGS';
export const SET_AGENTS_FILTER = 'SET_AGENTS_FILTER';
export const AGENTS_CATALOGS_ERROR = 'AGENTS_CATALOGS_ERROR';
export const RESET_PAYMENT_LOADING = 'RESET_PAYMENT_LOADING';
export const RESET_DOMICILIATION_LOADING = 'RESET_DOMICILIATION_LOADING';
const REACT_APP_API_KEY_GATEWAY = runtimeConfig.API_KEY_GATEWAY;

export const createAgent = async params => {
  let data = {};
  try {
    const resp = await fetchWithAuth(`${AGENT_BASE}`, {
      method: 'POST',
      headers: {
        Authorization: `${REACT_APP_API_KEY_GATEWAY}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(params)
    });
    if (get(resp, 'status') === 200) {
      data = await resp.json();
    } else if (get(resp, 'status') >= 400 && get(resp, 'status') < 600) {
      const error = await resp.json();
      throw error;
    }
  } catch (error) {
    throw error;
  }

  return data;
}; // END createAgent

export const editAgent = async (params, uuid) => {
  let data = {};
  try {
    const resp = await fetchWithAuth(`${AGENT_BASE}/${uuid}`, {
      method: 'PATCH',
      headers: {
        Authorization: `${REACT_APP_API_KEY_GATEWAY}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(params)
    });
    if (get(resp, 'status') === 200) {
      data = await resp.json();
    } else if (get(resp, 'status') >= 400 && get(resp, 'status') < 600) {
      const error = await resp.json();
      throw error;
    }
  } catch (error) {
    throw error;
  }

  return data;
}; // END editAgent

export const deleteAgent = async uuid => {
  let data = {};
  try {
    const resp = await fetchWithAuth(`${AGENT_BASE}/${uuid}`, {
      method: 'DELETE',
      headers: {
        Authorization: `${REACT_APP_API_KEY_GATEWAY}`,
        'Content-Type': 'application/json'
      }
    });
    if (get(resp, 'status') === 200) {
      data = await resp.json();
    } else if (get(resp, 'status') >= 400 && get(resp, 'status') < 600) {
      const error = await resp.json();
      throw error;
    }
  } catch (error) {
    throw error;
  }

  return data;
}; // END deleteAgent

export const getAgents = async params => {
  const qsObj = {};
  const { page, limit } = params;

  if (page) qsObj.page = page;
  if (limit) qsObj.limit = limit;

  let data;
  try {
    const resp = await fetchWithAuth(`${AGENT_BASE}?${qs.stringify(qsObj)}`, {
      method: 'GET',
      headers: {
        Authorization: `${REACT_APP_API_KEY_GATEWAY}`,
        'Content-Type': 'application/json'
      }
    });
    if (get(resp, 'status') === 200) {
      data = await resp.json();
    } else if (get(resp, 'status') >= 400 && get(resp, 'status') < 600) {
      const error = await resp.json();
      throw error;
    }
  } catch (error) {
    throw error;
  }

  return data;
}; //END getAgents

export function deleteselectedPaymentPending(data) {
  return dispatch =>
    Promise.resolve(
      dispatch({
        type: DELETE_SELECTED_PAYMENTS,
        payload: data
      })
    );
}
export function selectedPaymentPending(data) {
  return dispatch =>
    Promise.resolve(
      dispatch({
        type: SELECTED_PAYMENTS,
        payload: data
      })
    );
}
export function resetSelectedPaymentPending() {
  return dispatch =>
    Promise.resolve(
      dispatch({
        type: RESET_SELECTED_PAYMENTS,
        payload: []
      })
    );
}

export const exportAgents = async () => {
  let data;
  try {
    const resp = await fetchWithAuth(`${AGENT_BASE}/report`, {
      method: 'GET',
      headers: {
        Authorization: `${REACT_APP_API_KEY_GATEWAY}`,
        'Content-Type': 'application/json'
      },
      responseType: 'blob'
    });
    if (get(resp, 'status') === 200) {
      data = await resp.blob();
    } else if (get(resp, 'status') >= 400 && get(resp, 'status') < 600) {
      const error = await resp.json();
      throw error;
    }
  } catch (error) {
    throw error;
  }

  return data;
}; // END exportAgents

export const exportAgent = async (agent_id, type, fileName, token) => {
  let data;
  try {
    const requestType = type === 'referenced_payments' ? 'pending_referenced' : type;
    const customAxios = applyAuth401Handler(axios.create());
    const resp = await customAxios.get(parseUrl(AGENT_REPORT, { type: requestType }), {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      params: {
        agent_id: agent_id
      },
      responseType: 'blob'
    });

    data = resp;
    downloadXls(data.data, fileName, 'agente');
  } catch (error) {
    throw error;
  }

  return data;
};

// SECURITY FIX H-017 (JWT expuesto en parametro de URL): tokencallcenter now
// travels via the standard `Authorization: Bearer <token>` header (same pattern
// already used by the global axios interceptor in src/app/intercept.js:54),
// instead of as a body field that mirrors the URL-exposed pattern this fix
// removes. The gateway's extractToken() (por-cobrar-gateway-sura/src/utils/authFunc.ts)
// already supports reading the token from either the body or the Authorization
// header, so no backend change is required. `token` is optional for backward
// compatibility with any other caller that still relies on the global
// interceptor picking up Redux's account.access_token automatically.
export const validateTokenCallCollection = (payload = {}, token) => {
  return async dispatch => {
    try {
      const headers = {
        'Content-Type': 'application/json'
      };
      if (token) {
        headers['Authorization'] = `Bearer ${token}`;
      }
      const response = await axios.post(AGENT_COLLECTION_BASE_CALL, payload, {
        headers
      });
      dispatch({
        type: VALIDATE_TOKEN,
        payload: response.data
      });
    } catch (error) {
      dispatch({
        type: VALIDATE_TOKEN_ERROR,
        payload: error.message
      });
    }
  };
};
export const validateTokenCollection = payload => {
  return async dispatch => {
    try {
      const response = await axios.post(AGENT_COLLECTION_BASE, payload, {
        headers: {
          'Content-Type': 'application/json'
        }
      });
      dispatch({
        type: VALIDATE_TOKEN,
        payload: response.data
      });
    } catch (error) {
      dispatch({
        type: VALIDATE_TOKEN_ERROR,
        payload: error.message
      });
    }
  };
};
const dateFilters = ['Fecha límite de pago', 'Fin de vigencia', 'Inicio de vigencia'];

const filterMapping = {
  oficina: 'office_id',
  ramo: 'product_id',
  moneda: 'currency',
  póliza: 'policy_id',
  recibo: 'invoice',
  'Fecha límite de pago': 'extension_date',
  'Fin de vigencia': 'due_date',
  'Inicio de vigencia': 'issue_date',
  'nombre cliente': 'customer_name'
};

const buildParams = searchValues => {
  const params = {};

  Object.keys(searchValues).forEach(filter => {
    const paramKey = filterMapping[filter];

    if (paramKey) {
      if (dateFilters.includes(filter) && searchValues[filter].length === 2) {
        params['date_type'] = paramKey;
        params['init_date'] = searchValues[filter][0];
        params['end_date'] = searchValues[filter][1];
      } else if (['póliza', 'recibo', 'nombre cliente'].includes(filter)) {
        if (searchValues[filter].trim() !== '') {
          params[paramKey] = searchValues[filter];
        }
      } else if (Array.isArray(searchValues[filter])) {
        searchValues[filter].forEach((value, index) => {
          const key = value.split(' - ')[0];
          params[`${paramKey}[${index}]`] = key;
        });
      } else {
        params[paramKey] = searchValues[filter];
      }
    }
  });

  if (!searchValues.date_type) {
    delete params.date_type;
    delete params.init_date;
    delete params.end_date;
  }

  return params;
};




export const getAgentsCatalog = tokenz => {
  return async dispatch => {
    try {
      const customAxios = applyAuth401Handler(axios.create());

      const response = await customAxios.get(AGENT_CATALOGS_DATA, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${tokenz}`
        }
      });
      dispatch({
        type: AGENTS_CATALOGS,
        payload: response.data
      });
    } catch (error) {
      console.error('Error in getAgentsCatalog:', error);
      dispatch({
        type: AGENTS_CATALOGS_ERROR,
        payload: {
          error: error.message,
          defaultCatalogs: {
            currencies: [],
            offices: [],
            branches: []
          }
        }
      });
    }
  };
};
export const getAgentsCurrency = () => {
  return async dispatch => {
    try {
      const customAxios = applyAuth401Handler(axios.create());
      const response = await customAxios.get(AGENT_CURRENCY, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `${REACT_APP_API_KEY_GATEWAY}`
        }
      });
      dispatch({
        type: AGENTS_CURRENCY,
        payload: response.data
      });
    } catch (error) {
      console.error('Error in validateTokenCollection:', error);
    }
  };
};
export const paymentRequestAgent = (token, payload) => {
  return async dispatch => {
    try {
      dispatch({
        type: AGENTS_PAYMENT_REQUEST_LOADING,
      });
      const customAxios = applyAuth401Handler(axios.create());
      const response = await customAxios.post(AGENT_PAYMENT_REQUEST, payload, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        }
      });
      dispatch({
        type: AGENTS_PAYMENT_REQUEST,
        payload: response.data
      });
      if (response.data && response.data.data.paymentLink) {
        window.location.href = response.data.data.paymentLink;
      }
    } catch (error) {
      dispatch({
        type: AGENTS_PAYMENT_REQUEST_ERROR,
        payload: error.response.data.error
      });
    }
  };
};

export const recurringPaymentRequestAgent = (token, payload) => {
  return async dispatch => {
    try {
      dispatch({
        type: AGENTS_PAYMENT_REQUEST_LOADING,
      });
      const customAxios = applyAuth401Handler(axios.create());
      const response = await customAxios.post(AGENT_RECURRING_PAYMENT_REQUEST, payload, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        }
      });
      dispatch({
        type: AGENTS_PAYMENT_REQUEST,
        payload: response.data
      });
      if (response.data && response.data.data.paymentLink) {
        window.location.href = response.data.data.paymentLink;
      }
    } catch (error) {
      let errorMessage = 'Error desconocido';
      
      if (error.response && error.response.data) {
        errorMessage = error.response.data.error || error.response.data.message || 'Error del servidor';
      } else if (error.message) {
        errorMessage = error.message;
      }
      
      dispatch({
        type: AGENTS_DOMICILIATION_REQUEST_ERROR,
        payload: errorMessage
      });
    }
  };
};

export const resetPaymentLoading = () => {
  return {
    type: RESET_PAYMENT_LOADING
  };
};

export const resetDomiciliationLoading = () => {
  return {
    type: RESET_DOMICILIATION_LOADING
  };
};

export const cancelReferenceAgent = (token, payload) => {
  return async dispatch => {
    try {
      const customAxios = applyAuth401Handler(axios.create());
      const response = await customAxios.post(AGENT_CANCEL_REFERENCES, payload, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        }
      });
      dispatch({
        type: AGENTS_CANCEL,
        payload: response.data
      });
    } catch (error) {
      dispatch({
        type: AGENTS_CANCEL,
        payload: error.message
      });
    }
  };
};

export function resetAgentsPending() {
  return dispatch =>
    Promise.resolve(
      dispatch({
        type: RESET_AGENTS_PENDINGS
      })
    );
}
export function setFlagFilter(isFilter) {
  return (dispatch) =>
    Promise.resolve(
      dispatch({
        type: SET_AGENTS_FILTER,
        payload: isFilter,
      })
    );
}

export const getAgentsPending = (page, limit, agent_id, id, token, searchValues = {}) => {
  return (dispatch) => {
    const params = {
      ...buildParams(searchValues),
      page: page,
      limit: limit,
      agent_id: agent_id,
      ...(searchValues.order_by && { order_by: searchValues.order_by }),
      ...(searchValues.order_dir && { order_dir: searchValues.order_dir }),
    };
    const allowedKeys = ["page", "limit", "agent_id", "order_by", "order_dir"];

    const containsOnlyAllowedKeys = Object.keys(params).every((key) =>
      allowedKeys.includes(key)
    );

    if (containsOnlyAllowedKeys) {
      dispatch(setFlagFilter(false));
      dispatch(resetAgentsPending()) 
      return Promise.resolve(); 
    }
    dispatch(setFlagFilter(true)); 

    const customAxios = applyAuth401Handler(axios.create());
    return customAxios
      .get(parseUrl(AGENT_COLLECTION_DATA, { id }), {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        params: params,
      })
      .then((response) => {
        dispatch({
          type: AGENTS_PENDINGS,
          payload: response.data,
        });
      })
      .catch((error) => {
        console.error("Error in getAgentsPending:", error);
        throw error; // Asegúrate de propagar el error
      });
  };
};

export const getRecurringPaymentInfo = (token, uuid) => {
  return async dispatch => {
    try {
      dispatch({
        type: AGENTS_PAYMENT_REQUEST_LOADING,
      });
      const customAxios = applyAuth401Handler(axios.create());
      const response = await customAxios.get(`${AGENT_PAYMENT_METHOD}/${uuid}`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        }
      });
      dispatch({
        type: AGENTS_PAYMENT_REQUEST,
        payload: response.data
      });
      return response.data;
    } catch (error) {
      dispatch({
        type: AGENTS_PAYMENT_REQUEST_ERROR,
        payload: error.response && error.response.data && error.response.data.error ? error.response.data.error : error.message
      });
      throw error;
    }
  };
};

export const cancelRecurringPayment = (token, uuid, reason) => {
  return async dispatch => {
    try {
      dispatch({
        type: AGENTS_PAYMENT_REQUEST_LOADING,
      });
      const customAxios = applyAuth401Handler(axios.create());
      const response = await customAxios.post(`${AGENT_CANCEL_RECURRING_PAYMENT}/${uuid}`, 
        { reason },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
          }
        }
      );
      dispatch({
        type: AGENTS_PAYMENT_REQUEST,
        payload: response.data
      });
      return response.data;
    } catch (error) {
      dispatch({
        type: AGENTS_PAYMENT_REQUEST_ERROR,
        payload: error.response && error.response.data && error.response.data.error ? error.response.data.error : error.message
      });
      throw error;
    }
  };
};

export const getPaymentReceiptHistory = (token, uuid, queryParams = '') => {
  return async dispatch => {
    try {
      dispatch({
        type: AGENTS_PAYMENT_REQUEST_LOADING,
      });

      const customAxios = applyAuth401Handler(axios.create());
      const url = `${AGENT_PAYMENT_RECEIPTS_HISTORY}/${uuid}/history?${queryParams}`;

      const response = await customAxios.get(
        url,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
          }
        }
      );

      dispatch({
        type: 'SET_PAYMENT_HISTORY',
        payload: {
          uuid,
          data: response.data
        }
      });

      return response.data;
    } catch (error) {
      dispatch({
        type: AGENTS_PAYMENT_REQUEST_ERROR,
        payload: error.response && error.response.data && error.response.data.error ? error.response.data.error : error.message
      });
      throw error;
    }
  };
};

export const getPaymentReportHistory = (token, uuid, queryParams = '') => {
  return async dispatch => {
    try {
      dispatch({
        type: AGENTS_PAYMENT_REQUEST_LOADING,
      });

      const customAxios = applyAuth401Handler(axios.create());
      const url = queryParams 
        ? `${AGENT_PAYMENT_REPORT_HISTORY}/${uuid}?${queryParams}`
        : `${AGENT_PAYMENT_REPORT_HISTORY}/${uuid}`;

      const response = await customAxios.get(
        url,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
          },
          responseType: 'blob'
        }
      );

      const fileName = `reporte_movimientos_${uuid}`;
      downloadXls(response.data, fileName, 'agente');

      dispatch({
        type: AGENTS_PAYMENT_REQUEST,
        payload: response.data
      });
      return response.data;
    } catch (error) {
      dispatch({
        type: AGENTS_PAYMENT_REQUEST_ERROR,
        payload: error.response && error.response.data && error.response.data.error ? error.response.data.error : error.message
      });
      throw error;
    }
  };
};


// WEBPACK FOOTER //
// ./src/redux/actions/agentActions.js